export enum ArcadePlatform {
  Core = 'core',
  RTPOS = 'rtpos',
  MSTeams = 'ms-teams',
  Slack = 'slack',
}
